'use client';

import React from 'react';
import Button from '../form/Button';
import QuizForm from './QuizForm';
import { useModalProvider } from '@dr-pam/common-components/Components/Modal/ModalProvider';
import type { ProgrammeWithCategories } from '@dr-pam/common-components/Services/Server/ProgrammeService';
import { trackQuizStart } from '../../utils/tracking';

type QuizButtonProps = {
	data?: ProgrammeWithCategories;
	asLink?: boolean;
	asPlainLink?: boolean;
	className?: string;
	onClickCapture?: (e: React.MouseEvent) => void;
	label?: string;
	hideIcon?: boolean;
	buttonClassName?: string;
};

export default function QuizButton(props: QuizButtonProps) {
	const {
		data,
		asLink = false,
		asPlainLink = false,
		className,
		onClickCapture,
		hideIcon,
		buttonClassName,
		label = 'Find your essentials',
	} = props;
	const modalProvider = useModalProvider();

	const hideQuizForm = () => {
		modalProvider.closeModal('quiz-modal');
	};

	const showQuizForm = () => {
		trackQuizStart();
		modalProvider.openModal({
			modalId: 'quiz-modal',
			className: 'blur',
			showClose: false,
			children: <QuizForm onClose={hideQuizForm} data={data} />,
		});
	};

	if (asPlainLink) {
		return (
			<a
				href="#"
				onClick={(e) => {
					e.preventDefault();
					showQuizForm();
				}}
				onClickCapture={onClickCapture}
				className={className}
				role="button"
				aria-haspopup="dialog"
			>
				{label}
			</a>
		);
	}

	if (asLink) {
		// used in footer
		return (
			<a
				href="#"
				onClick={(e) => {
					e.preventDefault();
					showQuizForm();
				}}
				onClickCapture={onClickCapture}
				className={`footer-link flex ac ${className ?? ''}`}
				role="button"
				aria-haspopup="dialog"
			>
				<span
					style={{
						WebkitMaskImage: 'url(/images/icons/dark-icons/FindAnswersNow.svg)',
						maskImage: 'url(/images/icons/dark-icons/FindAnswersNow.svg)',
						width: '30px',
						height: '30px',
						display: 'inline-block',
						flexShrink: 0,
						backgroundColor: 'currentColor',
						maskSize: 'contain',
						maskRepeat: 'no-repeat',
						maskPosition: 'center',
						WebkitMaskSize: 'contain',
						WebkitMaskRepeat: 'no-repeat',
						WebkitMaskPosition: 'center',
					}}
					aria-hidden="true"
				/>
				<span>{label.toLowerCase()}</span>
			</a>
		);
	}

	const defaultButtonClassName = buttonClassName ?? 'Button solid light icon quiz-button';

	return (
		<Button className={`${defaultButtonClassName} ${className ?? ''}`} onClick={showQuizForm}>
			{!hideIcon && (
				// eslint-disable-next-line @next/next/no-img-element
				<img src="/images/icons/navigate.svg" width={34} height={34} alt="navigate-icon" />
			)}
			<span>{label}</span>
		</Button>
	);
}
